/**/  
  
  
  
  /* Header / megamenu*/ 
  $(document).on('mouseover', '.widemenu__item-heading', function(){
    var listMenuValue = $(this).data("menu-list-value");
    console.log("Mouse in (over)" + listMenuValue);
    $('.widemenu__item-heading').each(function(index){
     if ($(this).hasClass('active')) {
       $(this).removeClass('active');
     }
   });
   if (!$(this).hasClass('active')) {
    $(this).addClass('active');
  }

  $('.sub-menu-container').each(function(index){
    $(this).css('display','none');
  });

  $('[data-submenu-container="' + listMenuValue + '"]').each(function(index){
    $(this).css('display','flex');
    });

  });
  
  /* Mobile mega  */

  // $(document).on('click', '.menu-item-has-children', function(){
  //   showSubMenu($(this));
  // });
  // $(document).on('click', '.menu-mobile-arrow', function(){
  //   hideSubMenu();
  // });
  // $(document).on('click', '.mobile_nav.dropdown_link', function(){
  //   hideSubMenu();
  // });
  
  document.addEventListener("scroll", (a) =>{
    let body_active = document.body.classList.contains('is-active');
    if ( body_active ){
      return;
    }

     if ( window.pageYOffset > 100 ){
      var main_mobile_nav = document.querySelector('.top-bar.mobile_nav__wrapper');
      main_mobile_nav.classList.remove('transparent-mobile-nav');
     }
     else {
      var main_mobile_nav = document.querySelector('.top-bar.mobile_nav__wrapper');
      if ( main_mobile_nav.classList.contains('white-fixed-mobile-nav') == false ){
        main_mobile_nav.classList.add('transparent-mobile-nav');
        console.log("scroll add trans nav");
      }
     }
  });

  document.addEventListener('DOMContentLoaded', function(){
    const menuArrow = document.querySelector('.mobile-menu-container .submenu--title-bar .menu-mobile-arrow');
    const subMenuTibleBar = document.querySelector('.mobile-menu-container .submenu--title-bar');
    const menuSections = document.querySelectorAll('.menu-item-has-children');
    const menuClosed = document.querySelector('.mobile_nav.dropdown_link');
    let subMenu;
    
    menuArrow.addEventListener('click', () => {
      hideSubMenu();
   }); 
   menuClosed.addEventListener('click', () => {
    hideSubMenu();
    hideSearch();
   });

   for (var i = 0, len = menuSections.length; i < len; i++) {
    menuSections[i].addEventListener('click',  function(){
      showSubMenu(this);
    });
  }
  
    function showSubMenu(hasChildren) {
      subMenu = hasChildren.querySelector('.menu-subs');
      subMenu.classList.add('active');
      subMenu.style.animation = 'slideLeft 0.5s ease forwards';
      
      var topBarTitle = subMenuTibleBar.querySelector('.submenu-topbar-title');
      topBarTitle.innerText = hasChildren.dataset.title;
      subMenuTibleBar.style.display = 'block';
      let mobile_menu_container = document.querySelector('.mobile-menu-container');
      mobile_menu_container?.setAttribute("style", "height: calc(100dvh - 176px);");
      
      // setTimeout(function () {
        
      // }, 500);
      var main_mobile_nav = document.querySelector('.top-bar.mobile_nav__wrapper');
      console.log("show sub menu "+main_mobile_nav.classList);
      main_mobile_nav.classList.remove('transparent-mobile-nav');
     
      
    }
    function hideSearch() {
      var mobile_search_bar_form = document.querySelector(".mobile-search-modal");
      mobile_search_bar_form.style.display = "none";
    }
    function hideSubMenu() {
      

      console.log(subMenu);
      if ( subMenu ){
        subMenuTibleBar.style.display = 'none';
        let mobile_menu_container = document.querySelector('.mobile-menu-container');
        mobile_menu_container?.setAttribute("style", "height: calc(100dvh - 106px);");
        subMenu.style.animation = 'slideRight 0.5s ease forwards';
        
        setTimeout(() => {
              subMenu.classList.remove('active');
              
        }, 300);
      }
    }
  
  })
  

//   const heading_list = document.querySelectorAll(".widemenu__item-heading");

//   heading_list.forEach(item => {
//     item.addEventListener("mouseover", event => {
//       console.log("Mouse in (over)");
      
//     });
//   });
//   $('[data-dropdown="' + megaMenuValue + '"]').each(function(index){
//     if (!$(this).hasClass('mega-menu')) {
//       $(this).remove();
//     }
//   });

//   item_heading.addEventListener("mouseout", event => {
//     console.log("Mouse out");
//   }); 

var auto_infinate_loading = false;
////////////////////////////////////////////////////////////////////////////////////////////
/* Blog list page - change category and load more logic */
////////////////////////////////////////////////////////////////////////////////////////////
$(".blog-category-slider .blog-category-slider--item a").click(function (e) {
  
  e.preventDefault();
  $(".blog-category-slider .blog-category-slider--item a").parent().removeClass("active");
  $(this).parent().addClass("active");

  $('.blog-block-container').hide();
  var blog_id = $(this).parent().attr("data-blog-id");
  console.log("slider category item click:"+blog_id);
  $("#blog-block-"+blog_id).show();
})

$('.js-load-more-blog').on('click', function(){
  if ( auto_infinate_loading || $(this).attr('disabled') ) {
    return;
  }

  var button_id = $(this).attr('id');
  var blog_id = button_id.split("load-more-blog-")[1];
  var blog_block_id = "#blog-block-" + blog_id;
  
  var $this =$(this),
  totalPages = parseInt($(blog_block_id + ' [data-all-pages]').val()),
  currentPage = parseInt($(blog_block_id + ' [data-this-page]').val()),
  datacollurl = $(blog_block_id + ' [data-coll-url]').val();;
  $this.attr('disabled', true);
  $this.addClass('hide');
  $('[loader]').removeClass('hide');
  // $this.find('[loader]').removeClass('hide');
  $this.find(blog_block_id + ' [load-more-text]').addClass('hide');
  $this.find(blog_block_id + ' [loader]').removeClass('hide');
  var nextUrl = $(blog_block_id + ' [data-next-link]').val();
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;
  //alert(current_page_new)
  //return false;
  console.log("load more blog_id:" + blog_id, "currentpage:" + currentPage, "Total page:"+totalPages);
  auto_infinate_loading = true;
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $(blog_block_id + ' [data-next-link]').val(datacollurl + "?page="+next_coll);
      $(blog_block_id + ' [data-this-page]').val(current_page_new);
      
      var blog_grid_id = '#blog-grid-' + blog_id;
      $(blog_grid_id).append($(responseHTML).find(blog_grid_id).html());
    },
    complete: function() {
      auto_infinate_loading = false;
      if(current_page_new < totalPages) {
        $this.attr('disabled', false); 
        $this.removeClass('hide');
        $this.find(blog_block_id + ' [load-more-text]').removeClass('hide'); 
        $this.find(blog_block_id + ' [loader]').addClass('hide');
        // $this.find('[loader]').addClass('hide');
        $('[loader]').addClass('hide');
      } 
      if(current_page_new >= totalPages) {
        $this.attr('disabled', true); 
        $this.addClass('hide');
        // $this.find('[loader]').addClass('hide');
        $('[loader]').addClass('hide');
      } 
    }
  })
 });

 ////////////////////////////////////////////////////////////////////////////////////////////
/* Ambassador list page - change category and load more logic */
////////////////////////////////////////////////////////////////////////////////////////////
$(".js-ambs-filter-item").click(function (e) {
  
  e.preventDefault();
  $(".js-ambs-filter-item").parent().removeClass("active");
  $(this).parent().addClass("active");

  $('.ambassador-block-container').hide();
  var block_id = $(this).parent().attr("data-block-id");
  console.log("slider category item click:"+block_id);
  $("#ambassador-block-"+block_id).show();
})

$('.js-load-more-ambs').on('click', function(){
  if ( auto_infinate_loading || $(this).attr('disabled') ){
    return;
  }
  
  var button_id = $(this).attr('id');
  var blog_id = button_id.split("load-more-ambs-")[1];
  var blog_block_id = "#ambassador-block-" + blog_id;
  
  var $this =$(this),
  totalPages = parseInt($(blog_block_id + ' [data-all-pages]').val()),
  currentPage = parseInt($(blog_block_id + ' [data-this-page]').val());
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $('[loader]').removeClass('hide');
  $this.find(blog_block_id + ' [load-more-text]').addClass('hide');
  $this.find(blog_block_id + ' [loader]').removeClass('hide');
  var nextUrl = $(blog_block_id + ' [data-next-link]').val();
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;
  //alert(current_page_new)
  //return false;
  console.log("load more blog_id:" + blog_id, "currentpage:" + currentPage, "Total page:"+totalPages, "nextUrl:"+nextUrl);
  auto_infinate_loading = true;
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      
      $(blog_block_id + ' [data-next-link]').val("?page_9a93ac3e="+next_coll);
      $(blog_block_id + ' [data-this-page]').val(current_page_new);
      
      var blog_grid_id = '#ambassador-grid-' + blog_id;
      // console.log($(responseHTML).find(blog_grid_id).html());
      $(blog_grid_id).append($(responseHTML).find(blog_grid_id).html());
    },
    complete: function() {
      auto_infinate_loading = false;
      if(current_page_new < totalPages) {
        $this.attr('disabled', false); 
        $this.removeClass('hide');
        $this.find(blog_block_id + ' [load-more-text]').removeClass('hide'); 
        $this.find(blog_block_id + ' [loader]').addClass('hide');
        // $this.find('[loader]').addClass('hide');
        $('[loader]').addClass('hide');
      } 
      if(current_page_new >= totalPages) {
        $this.attr('disabled', true); 
        $this.addClass('hide');
        // $this.find('[loader]').addClass('hide');
        $('[loader]').addClass('hide');
      } 
    }
  })
 });

  ////////////////////////////////////////////////////////////////////////////////////////////
/* Prepare page - load more logic */
////////////////////////////////////////////////////////////////////////////////////////////

$('.js-load-more-products').on('click', function(){
    
  if (auto_infinate_loading || $(this).attr('disabled')) {
    return;
  }

  var $this =$(this),
  totalPages = parseInt($('[data-all-pages]').val()),
  currentPage = parseInt($('[data-this-page]').val()),
  datacollurl = $('[data-coll-url]').val();;
  $this.attr('disabled', true);
  $this.find('[load-more-text]').addClass('hide');
  $this.find('[loader]').removeClass('hide');
  var nextUrl = $('[data-next-link]').val();
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  // $this.find('[loader]').removeClass('hide');
  $('[loader]').removeClass('hide');
  $this.addClass('hide');
  auto_infinate_loading = true;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('[data-next-link]').val("?page="+next_coll);
      $('[data-this-page]').val(current_page_new);
      
      $('#product-grid').append($(responseHTML).find('#product-grid').html());
    },
    complete: function() {
      auto_infinate_loading = false;
      if(current_page_new < totalPages) {
        $this.attr('disabled', false); 
        $this.find('[load-more-text]').removeClass('hide'); 
        // $this.find('[loader]').addClass('hide');
        $('[loader]').addClass('hide');
      } 
      if(current_page_new >= totalPages) {
        $this.attr('disabled', true);
        $this.addClass('hide');
        // $this.find('[loader]').addClass('hide');
        $('[loader]').addClass('hide');
      } 
    }
  })
 });

 // Infinate scroll load...
 window.addEventListener("scroll", (event) => {
  let scroll = this.scrollY;
  var height = window.innerHeight;

  // Prepare product grid infinate scroll load
  if ( $('.js-load-more-products').offset() != undefined ) {
    let element_pos =  $('.js-load-more-products').offset().top - height;
    if ( element_pos <= scroll ){
      console.log(element_pos);
      $('.js-load-more-products').click();
    }
  }
  
  // Blog grid infinate scroll load
  $('.js-load-more-blog').each(function() {
    if ( $( this ).offset() != undefined ) {
      let element_pos1 =  $( this ).offset().top - height;
      if ( element_pos1 < 0 )
        return;
      console.log(element_pos1);
      if ( element_pos1 <= scroll ){
        
        $( this ).click();
      }
    }
  });
  
  // Ambassador grid infinate scroll load
  $('.js-load-more-ambs').each(function() {
    // return;
    if ( $( this ).offset() != undefined ) {
      let element_pos2 =  $( this ).offset().top - height;
      if ( element_pos2 < 0 )
        return;
      console.log(element_pos2);
      if ( element_pos2 <= scroll ){
        
        $( this ).click();
      }
    }
  });
  
});

const getWidget = (input) => {
  var myInterval = setInterval(widgetLoaded, 100);

  function widgetLoaded () {
    let widget = document.querySelector(".search_results-container");
    let lis = widget?.querySelector(".predictive-search__query-suggestions")?.querySelectorAll(".predictive-search__list-item");

    if (widget && lis && lis?.length > 0) {
      clearInterval(myInterval);
      
      lis.forEach(li => {
        console.log(li);
        li.querySelector("a").addEventListener("click", function () {
          console.log(this.textContent);
          input.value = this.textContent;
          const keydownEvent = new KeyboardEvent('keydown', {
            key: `${this.textContent}`,
          });
          input.dispatchEvent(keydownEvent);
          setTimeout(function () {
            input.focus();
          }, 100);
        })
      })
    } else {
      console.log("Search Result Widget => Loading...");
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  function waitForElement(selector, callback) {
    const intervalId = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(intervalId);
        callback();
      }
    }, 500);
  }
  
  (function () {
    let searchInputs = document.querySelectorAll("header .search-form__input");
    
    document.querySelectorAll(".search-form")?.forEach(form => {
      form.addEventListener("submit", (e) => {
        console.log(form);
        e.preventDefault();
      })
    })

    searchInputs?.forEach(input => {
      console.log(input);
      input.addEventListener("keydown", function () {
        setTimeout(function () {
          getWidget(input);
        }, 500);
      });
      input.addEventListener("focus", () => {
        setTimeout(function () {
          getWidget(input);
        }, 500);
      });
    });

    const pageRetailer = document.querySelector(".page-retailer");
    setTimeout(function () {
      pageRetailer?.querySelectorAll("input[type='file']")?.forEach(input => {
        console.log(input);
        const fileLabel = document.createElement('label');
        fileLabel.classList.add('custom-file-label');
        fileLabel.classList.add('empty');
        fileLabel.textContent = 'No file chosen';
  
        console.log(fileLabel);
  
        input.parentNode.append(fileLabel);
  
        input.addEventListener('change', function() {
          if (this.files.length > 0) {
            fileLabel.textContent = this.files[0].name;
            fileLabel.classList.remove('empty');
          } else {
            fileLabel.textContent = 'No file chosen';
            fileLabel.classList.add('empty');
          }
        });

        fileLabel.addEventListener("click", function () {
          console.log(input);
          input.click();
        });
      })
    }, 1000);
    
  })();

  // For mobile view, adjust the RTB icon bar's position
  setTimeout(function () {
    let rtb_bar = document.querySelector(".column_icons_slider");
    let gf_products = document.querySelector("#gf-products");
    console.log("adjust rtb bar");
    console.log(rtb_bar);
    if ( gf_products && rtb_bar )
    {
      gf_products.before(rtb_bar);
      console.log("added rtb bar!!!!");
    }
  }, 500);

  // Stikcy filter
  waitForElement("#gf-controls-container", () => {
    let gf_grid_controls = document.querySelector("#gf-controls-container");
    let globo_rtb = document.querySelector(".globo_rtb");
    
    if ( gf_grid_controls && globo_rtb )
    {
      gf_grid_controls.before(globo_rtb);
      
    }
  });

  waitForElement(".globo-selected-items-wrapper.visible-xs", () => {
    let filter_buttons = document.querySelectorAll(".globo-selected-items-wrapper.visible-xs");
    filter_buttons?.forEach(filter => {
      filter.addEventListener("click", function (e) {
          setTimeout(function () {
            const y = document.getElementById('gf-grid')?.getBoundingClientRect().top + window.scrollY - 105;
            window.scroll({
              top: y,
              behavior: 'smooth'
            });
          }, 200);
      });
    });

  });

  // Fix Where-to-buy page ADA errors
  // Missing alternative text for AjaxLoader.gif - #loading_mask_loader img
  // 2 Missing form label id: store_search, .gr-search-slt #address
  /*
  setTimeout(function () {
    let loader_image = document.querySelector("#loading_mask_loader img");
    let store_search_input = document.querySelector("#store_search");
    let store_address_input = document.querySelector(".gr-search-slt #address");
    
    if ( loader_image ){
      loader_image.setAttribute("alt","AjaxLoader");
    }
    
    if ( store_search_input ){
      store_search_input.setAttribute("aira-label","Store search");
    }

    if ( store_address_input ){
      store_address_input.setAttribute("aira-label","Address search");
    }

  }, 1000);
  */
  waitForElement("#loading_mask_loader img", () => {
    let loader_image = document.querySelector("#loading_mask_loader img");
    if ( loader_image ){
      loader_image.setAttribute("alt","AjaxLoader");
      console.log("Where to Buy: Fix loader image");
    }
  });
  waitForElement("#store_search", () => {
    let store_search_input = document.querySelector("#store_search");
    if ( store_search_input ){
      store_search_input.setAttribute("aria-label","Store search");
      console.log("Where to Buy: Fix store search");
    }
  });
  waitForElement(".gr-search-slt #address", () => {
    let store_address_input = document.querySelector(".gr-search-slt #address");
    if ( store_address_input ){
      store_address_input.setAttribute("aria-label","Address search");
      console.log("Where to Buy: Fix address search");
    }
  });

  
//   (function(history){
//     const pushState = history.pushState;
//     history.pushState = function(state) {
//         if (typeof history.onpushstate == "function") {
//             history.onpushstate({state: state});
//         }
//         // Call your custom function here
//         setTimeout(function () { 
//           console.log('url: ' + window.location.href);
//         }, 500);
//         return pushState.apply(history, arguments);
//     }
// })(window.history);

  // Fix Become a Retailer page ADA error - .globo-form-control .classic-label
   setTimeout(function () {
     let classic_labels = document.querySelectorAll(".globo-form-control .classic-label");
    
    classic_labels?.forEach((label) => {
      if ( !label.hasAttribute("for") && label.innerText == '' ){
        console.log("label text:" + label.innerHTML);
        label.remove();
      }
    });

   }, 500);
  
  // Instagram app customize
  // 
  waitForElement(".instafeed-new-layout-wrapper", () => {
    let instafeed_layout = document.querySelector(".instafeed-new-layout-wrapper");
    return;
    // Element-specific code here
    console.log("instafeed-slider initialize");
    instafeed_layout.classList.add("instafeed-slider");
    instafeed_layout.classList.add("flickity-enabled");
    instafeed_layout.setAttribute('data-flickity', '');

    var instafeed_slider = document.querySelector('.instafeed-slider');
    flkty_instafeed_images = new Flickity( instafeed_slider, {
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: true,
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: 'left',
        /*cellAlign,*/
        pageDots: false,
        contain: true,
        /*freeScroll: true,*/
        /*initialIndex: 0*/
    });
  });

  // setTimeout(function () {
  //   let instafeed_layout = document.querySelector(".instafeed-new-layout-wrapper");
  //   if ( instafeed_layout ){
  //     console.log("instafeed-slider initialize");
  //     instafeed_layout.classList.add("instafeed-slider");
  //     instafeed_layout.classList.add("flickity-enabled");
  //     instafeed_layout.setAttribute('data-flickity', '');
  //   }
  //   //<div class="ambs-image-slider flickity-enabled" data-flickity></div>
  //   // console.log("instafeed-slider initialize");
  //   var images_slider = document.querySelector('.instafeed-slider');
  //   flkty_amb_images = new Flickity( images_slider, {
  //       lazyLoad: 2,
  //       imagesLoaded: true,
  //       draggable: true,
  //       prevNextButtons: true,
  //       wrapAround: true,
  //       cellAlign: 'left',
  //       /*cellAlign,*/
  //       pageDots: false,
  //       contain: true,
  //       /*freeScroll: true,*/
  //       /*initialIndex: 0*/
  //   });

  // }, 500);

  /* Show OneTrust settings dialog */
  document.querySelector(".js-cookie-settings-button")?.addEventListener("click", function (e) {
    e.preventDefault();
    
    if ( OneTrust ){
      OneTrust.ToggleInfoDisplay();
    }
    else {
      console.log("OneTrust SDK is not loaded.");
    }
    
  });

  /* General Collection pages Adjustments - BIS button action to PDP */
//   document.querySelectorAll(".inline-quickshop .klaviyo-bis-trigger1")?.forEach(function (item, idx) {
//     item.addEventListener('click', function (e) {
//       e.preventDefault();
//         console.log("bis-trigger click");
//     });
// });
//   document.querySelectorAll(".inline-quickshop .klaviyo-bis-trigger")?.forEach(input => {
//     input?.addEventListener("click", function (e) {
//       console.log(e);
//       console.log(this);
//       e.preventDefault();
//       var product_url = e.getAttribute("data-link");
//       console.log("product url: " + product_url);
//       window.location.href = product_url;
//     });
//   });

  /* Hook Flavor Idea Submit button */
  setTimeout(function () {
    let submit_button = document.querySelector("#globo-formbuilder-120738 .wizard__submit");
    if ( submit_button )
    {
      console.log("Globo formbuilder 120738: submit click");
      submit_button.onclick = function() {
        setTimeout(function () {
          let has_errors = document.querySelectorAll("#globo-formbuilder-120738 .globo-form-control.has-error");
          let check_subscribe = document.getElementById('120738-acceptTerms-1');
          if ( has_errors.length == 0 && check_subscribe.checked){
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'TLt4ms']);
            console.log("Globo formbuilder 120738: submit click");
          }
        }, 200);
        
      };
      
    }
  }, 1000);
  
  
   var mainFlkty = new Flickity( '.year-slider-main', {
     sync: '.year-slider-nav',
   });
  
  var navFlkty = new Flickity( '.year-slider-nav', {
     asNavFor: ".year-slider-main",
    contain: true,
  });
  
  // select on nav click
  navFlkty.on( 'change', function( index ) {
    console.log('navflkty change:' + index)
    mainFlkty.select( index );
  });

  
/* Custom the Recharge bundle widget */
  // document.querySelector('#recharge-bundles .rb-container form button.rb-btn').addEventListener('click', function(event) {
  //   event.preventDefault();
  //   // Custom logic goes here
  //   console.log("The Recharge bundle --------- Add to Cart");
  //   window.location.href = '/custom-page'; // Example of a redirect
  // });

})

/* add custom code */
/* custom js code */

window.RechargeBundle = {
  onAddToCart: () =>  {
    // Open slide cart
    console.log("The Recharge bundle --------- Add to Cart");
  }
}